import { render, staticRenderFns } from "./CreateRouteManually.vue?vue&type=template&id=385b573b&scoped=true&"
import script from "./CreateRouteManually.vue?vue&type=script&lang=js&"
export * from "./CreateRouteManually.vue?vue&type=script&lang=js&"
import style0 from "./CreateRouteManually.vue?vue&type=style&index=0&id=385b573b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b573b",
  null
  
)

export default component.exports